var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeElement)?_c('div',{staticClass:"sharing"},[(_vm.canShareElement(_vm.activeElement))?_c('div',[_c('ShareForm',{attrs:{"shares":_vm.shares},on:{"add":_vm.addShare,"update":_vm.updateShare}}),_vm._v(" "),_c('ShareList',{attrs:{"shares":_vm.shares},on:{"remove":_vm.removeShare,"update":_vm.updateShare}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }